import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteJob(jobId: string) {
	const response = await fetch(`${apiEndpoint}/jobs/${jobId}`, {
		method: 'DELETE',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
}